module.exports = __webpack_public_path__ + "img/s7pLogo4.f931266c.svg";